import * as actionTypes from 'constants/ActionTypes';

const initState = {
    loading: false,
    page: 1,
    next: 2,
    previous: 1,
    limit: 25,
    sortField: 'addedAt',
    sortValue: -1,
    filters: {
        search: '',
    },
    data: [],
};

const subscribers = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.GET_SUBSCRIBERS.REQUEST:
            return {
                ...state,
                ...action.pagination,
                loading: false,
            };
        case actionTypes.GET_SUBSCRIBERS.SUCCESS: {
            return {
                ...state,
                ...action.data,
                loading: true,
            };
        }
        case actionTypes.GET_SUBSCRIBERS.FAILURE:
            return {
                ...state,
                ...action.data,
                loading: true,
            };

        default:
            return state;
    }
};

export default subscribers;



// WEBPACK FOOTER //
// ./app/reducers/users/subscribers.js